import { z } from 'zod';
import { ValidationError } from './errors/index.js';
import { Injection } from './injection/Injection.js';
import { Result } from './result/Result.js';
/**
 * Xero account type classifications.
 *
 * These mirror the Xero API's `AccountType` enum (from xero-node SDK).
 * Values are the raw Xero codes, not display names.
 */
export var XeroAccountType;
(function (XeroAccountType) {
    XeroAccountType["BANK"] = "BANK";
    XeroAccountType["CURRENT"] = "CURRENT";
    XeroAccountType["CURRLIAB"] = "CURRLIAB";
    XeroAccountType["DEPRECIATN"] = "DEPRECIATN";
    XeroAccountType["DIRECTCOSTS"] = "DIRECTCOSTS";
    XeroAccountType["EQUITY"] = "EQUITY";
    XeroAccountType["EXPENSE"] = "EXPENSE";
    XeroAccountType["FIXED"] = "FIXED";
    XeroAccountType["INVENTORY"] = "INVENTORY";
    XeroAccountType["LIABILITY"] = "LIABILITY";
    XeroAccountType["NONCURRENT"] = "NONCURRENT";
    XeroAccountType["OTHERINCOME"] = "OTHERINCOME";
    XeroAccountType["OVERHEADS"] = "OVERHEADS";
    XeroAccountType["PAYG"] = "PAYG";
    XeroAccountType["PREPAYMENT"] = "PREPAYMENT";
    XeroAccountType["REVENUE"] = "REVENUE";
    XeroAccountType["SALES"] = "SALES";
    XeroAccountType["TERMLIAB"] = "TERMLIAB";
})(XeroAccountType || (XeroAccountType = {}));
/**
 * Case-normalising Zod schema for `XeroAccountType`. Accepts any casing and
 * produces the canonical upper-case enum member. Values outside the enum
 * fail parsing.
 */
export const XeroAccountTypeSchema = z
    .string()
    .transform((v) => v.toUpperCase())
    .pipe(z.nativeEnum(XeroAccountType));
/**
 * Injection between `XeroAccountType` and its canonical string representation.
 * `invert` accepts any string (e.g., values read from a BigQuery row) and
 * fails with `ValidationError` when it's not one of the enum members.
 */
export const xeroAccountTypeInjection = new Injection((t) => t, (s) => {
    const parsed = XeroAccountTypeSchema.safeParse(s);
    return parsed.success ? Result.ok(parsed.data) : Result.error(new ValidationError(`Invalid XeroAccountType: ${s}`));
});
//# sourceMappingURL=XeroAccountType.js.map